document.addEventListener("DOMContentLoaded", function () {
  let userInteracted = false;

  function loadHubSpotScript() {
    if (!userInteracted) {
      userInteracted = true;
      const script = document.createElement("script");
      script.src = "//js.hs-scripts.com/44963351.js";
      script.async = true;
      script.defer = true;
      script.id = "hs-script-loader";
      document.head.appendChild(script);
    }
  }

  ["scroll", "mousemove", "keydown"].forEach((event) => {
    window.addEventListener(event, loadHubSpotScript, { once: true });
  });
});
